import { Platform } from 'react-native';

/**
 * On web a clicked control keeps focus, and Pressable paints its focus state for any focus, so
 * controls whose focus state misreads after a click keep it for keyboard focus only. Focus moved
 * by script counts as keyboard focus only when the browser would show it, i.e. after keyboard use.
 * Native, and browsers without `:focus-visible`, always count as keyboard focus.
 */
export function isKeyboardFocus(target: unknown) {
  if (Platform.OS !== 'web') {
    return true;
  }
  try {
    return (target as Element).matches(':focus-visible');
  } catch {
    return true;
  }
}
